module.exports = __webpack_public_path__ + "img/CY.b1a37d23.svg";